import { render, staticRenderFns } from "./ActiveProjectDetails.vue?vue&type=template&id=d4894fc6"
import script from "./ActiveProjectDetails.vue?vue&type=script&lang=ts"
export * from "./ActiveProjectDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports